// extracted by mini-css-extract-plugin
module.exports = {"container":"OpenDistributionButton_container__fvceW","inverted":"OpenDistributionButton_inverted__J6ok_","outputInfo":"OpenDistributionButton_outputInfo__eSrae"};